import { SET_TAX_MESSAGE_START } from './textMessageDetailTypes';

export const setTaxMessageStart = ({ isEnable, taxMessageText }) => ({
  type: SET_TAX_MESSAGE_START,
  payload: {
    isEnable,
    taxMessageText
  }
});
